import { Navigate, useLocation, useParams } from 'react-router-dom'

export const RedirectWithParamsAndQuery = ({ to }: { to: string }) => {
  const params = useParams()
  const location = useLocation()

  // Replace route params in `to` path
  let path = to

  Object.entries(params).forEach(([key, value]) => {
    path = path.replace(`:${key}`, value ?? '')
  })

  // Preserve query string + hash
  const search = location.search || ''
  const hash = location.hash || ''

  return <Navigate replace to={`${path}${search}${hash}`} />
}
